"use client";

import React, { Suspense } from 'react';
import Image from "next/legacy/image";

interface Service {
  id: number;
  title: string;
  description: string;
  icon: string;
}

const services: Service[] = [
  {
    id: 1,
    title: "Building",
    description: "Professional building services for residential and commercial properties.",
    icon: "/images/hammer.svg",
  },
  {
    id: 2,
    title: "Electrical",
    description: "Professional electrical services for residential and commercial properties.",
    icon: "/icons/electrical.svg",
  },
  {
    id: 3,
    title: "Plumbing",
    description: "Expert plumbing services to ensure your water systems are running smoothly.",
    icon: "/icons/plumbing.svg",
  },
  {
    id: 4,
    title: "Roofing",
    description: "High-quality roofing services to protect your home from the elements.",
    icon: "/icons/roofing.svg",
  },
  {
    id: 5,
    title: "Painting",
    description: "Interior and exterior painting services to give your property a fresh look.",
    icon: "/icons/painting.svg",
  },
  {
    id: 6,
    title: "Flooring",
    description: "Professional flooring installation and repair services.",
    icon: "/icons/floor.svg",
  },
  {
    id: 7,
    title: "Tiling",
    description: "Expert tiling services for bathrooms, kitchens, and more.",
    icon: "/icons/tiles.svg",
  },
  {
    id: 8,
    title: "Landscaping",
    description: "Comprehensive landscaping services to enhance your outdoor spaces.",
    icon: "/icons/landscape.svg",
  },
  {
    id: 9,
    title: "Heatpump Installationg",
    description: "Heating, ventilation, and air conditioning services to keep your home comfortable.",
    icon: "/icons/hvac.svg",
  },
  {
    id: 10,
    title: "Plasterboard Installation",
    description: "Professional plasterboard installation and repair services.",
    icon: "/icons/plaster.svg",
  },
  {
    id: 11,
    title: "Cladding Installation",
    description: "High-quality cladding installation to improve your home's exterior.",
    icon: "/images/home.svg",
  },
  {
    id: 12,
    title: "Window and Door Installation",
    description: "Expert window and door installation services for improved energy efficiency.",
    icon: "/icons/window.svg",
  },
  {
    id: 13,
    title: "Concrete Work",
    description: "Professional concrete work for driveways, patios, and more.",
    icon: "/icons/concrete.svg",
  },
  {
    id: 14,
    title: "Insulation Installation",
    description: "Expert insulation installation to improve your home's energy efficiency.",
    icon: "/icons/fire.svg",
  },
  {
    id: 15,
    title: "Gutter Installation",
    description: "High-quality gutter installation to protect your home from water damage.",
    icon: "/icons/drainage.svg",
  },
];

export default function Services() {
  const bodyFont = "font-sans font-semibold";

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <p className="text-l font-semibold text-green-600 mb-2 text-center uppercase">Services</p>
        <h2 className="text-3xl font-bold mb-8 text-center">Range of services and offerings</h2>
        <p className={`${bodyFont} text-center text-gray-700 mb-8`}>Whether you just want to build or have a range of works to complete we have you covered. We work closely with local trusted tradesmen including but not limited to:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-lg shadow-lg p-6 text-center">
              <Suspense fallback={<div>Loading...</div>}>
                <Image src={service.icon} alt={service.title} width={64} height={64} className="w-16 h-16 mx-auto mb-4" />
              </Suspense>
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className={`${bodyFont} text-gray-600`}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

